<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='住陪管理用户' label2="修改住陪管理用户" url="/person/zpgluser/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">姓名：</label>
            <div class="col-xl-3">
              <el-form-item prop="realname" :rules="{required: true, message: '姓名不能为空', trigger: 'blur'}">
                <el-input v-model="form.realname" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">工号：</label>
            <div class="col-xl-3">
              <el-form-item prop="cardno" :rules="{required: true, message: '工号不能为空', trigger: 'blur'}">
                <el-input v-model="form.cardno" placeholder="请输入工号"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">性别：</label>
            <div class="col-xl-3">
              <el-form-item prop="sex" :rules="{required: true, message: '性别不能为空', trigger: 'blur'}">
                <el-select v-model="form.sex" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">出生日期：</label>
            <div class="col-xl-3">
              <el-form-item prop="birthday" :rules="{required: true, message: '出生日期不能为空', trigger: 'blur'}">
                <el-date-picker v-model="form.birthday" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">科室：</label>
            <div class="col-xl-3">
              <el-form-item prop="section" :rules="{required: true, message: '科室不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model="form.section" :dictid='this.$utils.DictEnum.section'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">学历：</label>
            <div class="col-xl-3">
              <el-form-item prop="edu" :rules="{required: true, message: '学历不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.edu' :dictid='this.$utils.DictEnum.edu'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">职称：</label>
            <div class="col-xl-3">
              <el-form-item prop="title" :rules="{required: true, message: '职称不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.title' :dictid='this.$utils.DictEnum.title'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">职务：</label>
            <div class="col-xl-3">
              <el-form-item prop="duty" :rules="{required: true, message: '职务不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.duty' :dictid='this.$utils.DictEnum.duty'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">人才：</label>
            <div class="col-xl-3">
              <el-form-item prop="personnel" :rules="{required: true, message: '人才不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.personnel' :dictid='this.$utils.DictEnum.personnel'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">岗位：</label>
            <div class="col-xl-3">
              <el-form-item prop="post" :rules="{required: true, message: '岗位不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.post' :dictid='this.$utils.DictEnum.post'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">支部：</label>
            <div class="col-xl-3">
              <el-form-item prop="branch" :rules="{required: true, message: '支部不能为空', trigger: 'blur'}">
                <ZPGLFormDictItemSelect v-model='form.branch' :dictid='this.$utils.DictEnum.branch'></ZPGLFormDictItemSelect>
              </el-form-item>
            </div>
            <label class="col-xl-2 col-form-label">角色类型：</label>
            <div class="col-xl-3">
              <el-form-item prop="roletype" :rules="{required: true, message: '角色类型不能为空', trigger: 'blur'}">
                <el-select v-model="form.roletype" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option v-for="item in roletypeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <SaveButton :url='saveUrl' back="/person/zpgluser/list"></SaveButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZPGLUserEdit',
  data () {
    return {
      form: {
        id: '',
        realname: '',
        cardno: '',
        sex: '',
        birthday: '',
        section: '',
        edu: '',
        duty: '',
        title: '',
        personnel: '',
        post: '',
        branch: '',
        roletype: '',
        token: ''
      },
      sexOptions: [{
        value: '1',
        label: '男'
      }, {
        value: '2',
        label: '女'
      }],
      roletypeOptions: [{
        value: '1',
        label: '带教老师'
      }, {
        value: '2',
        label: '住培生'
      }],
      saveUrl: this.$utils.Url.zpgl + '/api/APIZPGLUser/Update'
    }
  },
  mounted: function () {
    this.form.token = sessionStorage.getItem('token')
    this.form.id = this.$route.params.id
    // 获取数据字典信息
    var args = {
      id: this.form.id,
      token: this.form.token
    }
    this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIZPGLUser/Info', args, function (data, model) {
      model.realname = data.Data.RealName
      model.cardno = data.Data.CardNo
      if(data.Data.Sex !== null){
        model.sex = String(data.Data.Sex)
      }
      if(data.Data.Birthday !== null){
        model.birthday = data.Data.Birthday
      }
      if(data.Data.Section !== null){
        model.section = data.Data.Section
      }
      if(data.Data.Edu !== null){
        model.edu = data.Data.Edu
      }
      if(data.Data.Duty !== null){
        model.duty = data.Data.Duty
      }
      if(data.Data.Title !== null){
        model.title = data.Data.Title
      }
      if(data.Data.Personnel !== null){
        model.personnel = data.Data.Personnel
      }
      if(data.Data.Post !== null){
        model.post = data.Data.Post
      }
      if(data.Data.Branch !== null){
        model.branch = data.Data.Branch
      }
      if(data.Data.RoleType !== null){
        model.roletype = String(data.Data.RoleType)
      }
    }, null, null, this.form)
  }
}
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-select {
    width: 100%;
  }
</style>
